// extracted by mini-css-extract-plugin
var _1 = "EmailProfileMessageHeader-moduleEmailProfileMessageHeader__ZnKGK";
var _2 = "EmailProfileMessageHeader-moduleactionsContainer__dEwc3";
var _3 = "EmailProfileMessageHeader-moduleadditionalInfo__nQUXJ";
var _4 = "EmailProfileMessageHeader-moduleclickable__o0QHx";
var _5 = "EmailProfileMessageHeader-modulecontainer__Gt3vQ";
var _6 = "EmailProfileMessageHeader-modulecreated__YJtXa";
var _7 = "EmailProfileMessageHeader-moduleinfoContainer__uQIVl";
var _8 = "EmailProfileMessageHeader-modulemail__z4lRx";
var _9 = "EmailProfileMessageHeader-modulemainInfoContainer__Cqowe";
var _a = "EmailProfileMessageHeader-modulename__TPH_K";
var _b = "EmailProfileMessageHeader-modulenameContainer__FHJzs";
var _c = "EmailProfileMessageHeader-modulepriority__AwO0H EmailPriorityTag-moduleEmailPriorityTag__bvVxa IconNG-moduleiconContainer__SxWZ0";
var _d = "EmailProfileMessageHeader-modulestatuses__tvEto";
var _e = "EmailProfileMessageHeader-moduletopInfoContainer__h74Ee";
export { _1 as "EmailProfileMessageHeader", _2 as "actionsContainer", _3 as "additionalInfo", _4 as "clickable", _5 as "container", _6 as "created", _7 as "infoContainer", _8 as "mail", _9 as "mainInfoContainer", _a as "name", _b as "nameContainer", _c as "priority", _d as "statuses", _e as "topInfoContainer" }
